// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2opwy","footer":"ChangeClinic_footer__2bEpL"};